// extracted by mini-css-extract-plugin
export default {"butonSwitch":"Import_butonSwitch__2KL8y","iconQuestion":"Import_iconQuestion__9O4ty"};